import { QuotePro, QuoteSimpleStatus } from '@jms/model';

import { defineStatusTag } from '../../shared/define.status.tag';

// Single source of Quote status colour. One function feeds both the manifest's board-card tag style
// and the manage surface header's tag deriver, so the two can never drift. 'neutral' doubles as the
// runtime fallback so an unknown/legacy status reads as Draft rather than rendering untoned.
export const quoteStatusTag = defineStatusTag<QuoteSimpleStatus, QuotePro>({
  [QuoteSimpleStatus.Draft]: 'neutral',
  [QuoteSimpleStatus.PendingApproval]: 'warning',
  [QuoteSimpleStatus.ChangesRequired]: 'warning',
  [QuoteSimpleStatus.Approved]: 'brand',
  [QuoteSimpleStatus.AwaitingAcceptance]: 'brand',
  [QuoteSimpleStatus.AwaitingPayment]: 'brand',
  [QuoteSimpleStatus.Accepted]: 'success',
  [QuoteSimpleStatus.Declined]: 'error',
  [QuoteSimpleStatus.Cancelled]: 'error',
}, 'neutral');
